import { Link, useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { useState } from 'react'

export default function Navbar() {
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)

  const isActive = (path) => location.pathname === path

  const navLinks = [
    { href: '/', label: 'Home' },
    { href: '/events', label: 'Events' },
    { href: '/contact', label: 'Contact' },
  ]

  return (
    <nav className="navbar-sticky bg-gradient-to-r from-orange-50 to-yellow-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Left - KLE Logo, College Name and Event Logo */}
          <Link to="/" className="flex items-center gap-2 sm:gap-3 -ml-6">
            <img 
              src="/kle-logo.png" 
              alt="KLE Society Logo" 
              className="h-10 sm:h-14 w-auto object-contain"
              style={{
                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
              }}
              onError={(e) => {
                e.target.style.display = 'none'
              }}
            />
            <div className="hidden sm:block">
              <p className="text-base font-bold text-kala-primary">KLE Society's</p>
              <p className="text-sm text-kala-secondary">college of BCA Gokak</p>
            </div>
            <div className="sm:hidden">
              <p className="text-sm font-bold text-kala-primary">KLE Society's</p>
              <p className="text-xs text-kala-secondary">college of BCA Gokak</p>
            </div>
            <img 
              src="/kalarava-logo.png" 
              alt="KALARAVA Logo" 
              className="hidden sm:block h-14 w-auto object-contain"
              style={{
                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
              }}
              onError={(e) => {
                e.target.style.display = 'none'
              }}
            />
          </Link>

          {/* Right - Navigation Links and Register Button */}
          <div className="hidden md:flex items-center gap-12">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-base font-bold transition-all duration-300 ${
                  isActive(link.href)
                    ? 'text-kala-orange border-b-2 border-kala-orange pb-1'
                    : 'text-kala-primary hover:text-kala-orange'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://forms.gle/KLEF3S1Ve5d5S9fv6"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gradient-blue-cyan text-lg font-bold px-16 py-4"
            >
              Register
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <X size={24} className="text-kala-primary" />
            ) : (
              <Menu size={24} className="text-kala-primary" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4 border-t border-kala-border animate-slide-down">
            <div className="flex flex-col gap-4 pt-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-sm font-medium transition-all duration-300 ${
                    isActive(link.href)
                      ? 'text-kala-orange'
                      : 'text-kala-secondary hover:text-kala-primary'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="https://forms.gle/KLEF3S1Ve5d5S9fv6"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gradient-blue-cyan text-sm text-center"
              >
                Register
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}
